import React from 'react'
import ComponentStyle from '../styles/Components.module.css'

function Map() {
  return (
    <div className={`${ComponentStyle.title}`}><h1>Map</h1></div>
  )
}

export default Map